/**
 * Logging wrapper to hide warnings on production
 */
export function warn() {
  if (process.env.NODE_ENV !== 'production') {
    for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
      messages[_key] = arguments[_key];
    }

    messages.forEach(function (message) {
      return console.warn("vwa-lsg: ".concat(message));
    });
  }
}
export function warnWithTrace() {
  if (process.env.NODE_ENV !== 'production') {
    for (var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      messages[_key2] = arguments[_key2];
    }

    // Only log as a group and add a stacktrace if run in the browser
    if (typeof window === 'undefined') {
      messages.forEach(function (message) {
        console.warn("vwa-lsg: ".concat(message));
      });
    } else {
      var disableComponentsCoreLogging = window.sessionStorage && window.sessionStorage.getItem('disableComponentsCoreLogging') || window.location.search && window.location.search.includes('disableComponentsCoreLogging');

      if (!disableComponentsCoreLogging) {
        messages.forEach(function (message) {
          console.groupCollapsed("vwa-lsg: ".concat(message));
          console.warn("vwa-lsg: ".concat(message));
          console.trace();
          console.groupEnd();
        });
      }
    }
  }
}